import { DiscoveryStatus } from '@/types/discovery.status.type';
import { FeatureLocks } from '@/types/feature.locks.type';
import { StageItem } from '@/types/stage.item.type';
import { Stage } from '@/types/stage.type';

export const isLockedFunction = (
  targetFunction: 'aimei' | 'library' | 'financials' | 'territories',
  stageList: Stage[],
  featureLocks: FeatureLocks | undefined,
  discoveryStatus: DiscoveryStatus | undefined
) => {
  if (stageList.length === 0) {
    return false;
  }

  if (
    discoveryStatus &&
    discoveryStatus.completed_stage_ids.includes(
      stageList[stageList.length - 1].id ?? ''
    )
  ) {
    return false;
  }

  if (featureLocks) {
    if (featureLocks?.[targetFunction]) {
      if (
        discoveryStatus &&
        discoveryStatus.completed_stage_ids.includes(
          featureLocks[targetFunction]
        )
      ) {
        return false;
      }
      return true;
    }

    return false;
  }

  return false;
};

export const isLockedDiscovery = (
  target: number,
  stageList: Stage[],
  discoveryStatus: DiscoveryStatus | undefined
) => {
  if (discoveryStatus === undefined) {
    return target > 0;
  }

  if (
    discoveryStatus.completed_stage_ids.includes(stageList[target].id ?? '')
  ) {
    return false;
  }

  if (target === 0) {
    return false;
  }

  if (
    discoveryStatus.completed_stage_ids.includes(stageList[target - 1].id ?? '')
  ) {
    return false;
  }

  return true;
};

export const getStageItemStatus = (
  target: number,
  stageId: string,
  stageItems: StageItem[],
  discoveryStatus: DiscoveryStatus | undefined
) => {
  if (discoveryStatus === undefined) {
    if (target === 0) {
      return 'active';
    }

    return 'locked';
  }

  if (discoveryStatus.completed_stage_ids.includes(stageId)) {
    return 'completed';
  }

  if (
    discoveryStatus.completed_stage_item_ids.includes(
      stageItems[target].id ?? ''
    )
  ) {
    return 'completed';
  }

  if (target > 0) {
    const completedItems = stageItems.filter((item) =>
      discoveryStatus.completed_stage_item_ids.includes(item.id ?? '')
    );

    if (completedItems.length === 0) {
      return 'locked';
    }

    if (
      stageItems.findIndex(
        (item) => item.id === completedItems[completedItems.length - 1].id
      ) ===
      target - 1
    ) {
      return 'active';
    }

    return 'locked';
  }

  return 'active';
};

export const getCurrentStage = (
  stageList: Stage[],
  discoveryStatus: DiscoveryStatus | undefined
) => {
  if (discoveryStatus === undefined) {
    return stageList[0];
  }

  const completedStages = discoveryStatus.completed_stage_ids;

  return stageList.find((stage) => !completedStages.includes(stage.id ?? ''));
};
